import { render, staticRenderFns } from "./Onhold.vue?vue&type=template&id=08220997&scoped=true&"
import script from "./Onhold.vue?vue&type=script&lang=js&"
export * from "./Onhold.vue?vue&type=script&lang=js&"
import style0 from "./Onhold.vue?vue&type=style&index=0&id=08220997&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08220997",
  null
  
)

export default component.exports